import {Heading, Text, Box, Center, Card, CardHeader, CardBody} from "@chakra-ui/react"
import { Global } from "@emotion/react";
import { Helmet } from 'react-helmet';
import Slider from "react-slick";
import { theme } from '@chakra-ui/react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ChristasParty() {
const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

    return (
    <>
    <Helmet>
      <title>Ką rengtis pagal Viliją Rušinskaitę - Apie kalėdinį laikotarpį</title>
      <meta name="description" content="Apie kalėdinį laikotarpį" />
      <meta property="og:title" content="Apie kalėdinį laikotarpį" />
      <meta property="og:description" content="Apie kalėdinį laikotarpį" />
      <meta property="og:image" content="https://karengtis.lt/vilija1_small.jpg" />
      <meta property="og:url" content="https://www.karengtis.lt/apie" />
    </Helmet>
    <Box minH='2vw' />
    <Center>
    <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Apie kalėdinį laikotarpį</Heading>
        </Center>
      </CardHeader>
    <Center>
    <CardBody pt='0'>
        <Box>
          <Text pt='0' fontSize='xl'>
Kiek tyros vaikystės magijos kalėdinis laikotarpis jums vis dar turi? Atsakykit nuoširdžiai, nenumoję ranka į visus dovanų sąrašus, darbinius vakarėlius, gaminimo virtuvėje arba blaškymosi tarp skirtingų miestų valandas lankantis pas kažką, kas darė savo ritualinius gaminimo pasiaukojimus (nebūtinai pagal jūsų mėgstamą skonių paletę), privalomus susibėgimus, kamščius ir jėga brukamą šventinę muziką su filmais kaip į "nieko tokio" emocinio krūvio kategoriją. 
Noriu galėti patikėti, kad tos magijos dar lieka pakankamai, bet realybėje prieššventinis laikotarpis ir suplanuotas šventimas juk dažniau būna performatyvus negu nuoširdus, šiltas ir jaukus. 
Ta nata noriu priminti, kad visa tai vistiek yra neišvengiama ir siūlau visame chaose, lėkime ir socialiniuose ritualuose vistiek paieškoti sau grožio, prasmės ir įkvėpimo. Tik kaip?
          </Text>
          <Text pt='2' fontSize='xl'> 
          Rengimasis, kuris įprastom gyvenimo aplinkybėmis yra automatizuotas procesas su asmeninėm išgrynintom ir optimizuotom formulėm (žinau, skamba kaip marketingo skyriaus slengas) tokiomis progomis irgi gali kiek apkarsti ar tapti iš pareigos daromu veiksmu, tai sugalvojau gudrybę, kaip sau perfrazuoti visą šventinę privalomybę ir atgauti daugiau savęs visame tame. Šventės ateina ir praeina su daug pokalbių apie šį bei tą, bet tikėtina - ne apie tai, kas jums dabar iš tikrųjų rūpi. Na, kas taip lengvai atveria savo širdies sopulius ir nerimus giminėms ir ima dalintis svarstymu apie skyrybas, politinę padėtį, klimato kaitą ar šokiruojantį didesnės apimties medicinių tyrimų trūkumą su moterimis ir jų sveikata? Visi truputį saugom savo tikrąsias mintis ir save, nuveždami į svečius savo abstraktesnę pokerface versiją. Ir nėra geresnio būdo dar geriau nukreipti dėmesio nuo ten, kur jums dabar skauda ar rūpi negu tiesiog pasimėgauti savo atrodymu. 
          </Text>
      <Box 
        mb="8" 
        ml="2"
        mx="auto"
        maxW={{ base: "70vw", md: "30vw" }}
        justifyContent="center"
      >
      <Global
        styles={`
          @media (min-width: ${theme.breakpoints.md}) {
            .slick-dots li button:before {
              color: #a0a0a0;
              opacity: 1;
            }
            .slick-dots li.slick-active button:before {
              color: #555555;
              opacity: 1;
            }
            .slick-prev:before,
            .slick-next:before {
              color: #a0a0a0;
            }
          }
        `}
      />
        <Slider {...settings}>
          <Box>
            <img src="/blog_pics/christmas_party_1.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_2.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_3.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_4.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_5.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_6.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_7.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_8.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_9.PNG" alt="kalėdinis derinys"/>
          </Box>
          <Box>
            <img src="/blog_pics/christmas_party_10.PNG" alt="kalėdinis derinys"/>
          </Box>
        </Slider>
      </Box>
          <Text pt='2' fontSize='xl'>
          Pagrindinis triukas ir įrankis yra tų švenčių nesureikšminti, neleisti joms jūsų šokdinti ir paversti šventinėmis marionetėmis su ugly bet ne ugly enough kalėdiniais megztiniais, kažkodėl visišku standartu tapusiomis šeimyninėmis fotosesijomis su džinsais ir baltais marškinėliais prie lapkričio mėnesį kalėdiškai dekoruotos fotostudijos eglutės (ar mes pavirtom iStock paveikslėliais?) Ir kažkuo spindinčiu arba raudonu, nors nelabai norisi ir nelabai tai jūsų dalykas. 
          </Text>
          <Box pt='2' minH='1vw' />
          <Text  fontSize='xl'> 
          Ko šiuo laikotarpiu norisi jums ir kas jums rengiantis dabar teikia džiaugsmą? Juk žiemos gūduma tradiciškai yra metas savirefleksijai, todėl rengdamiesi darbiniams kalėdiniams vakarėliams, susibėgimams su savo bendruomene, draugais ar susibūrimams su šeima galit prisiminti sau svarbią asmeninę simboliką, lydėjusią ir stiprinusią visus metus, o gal ir nuo pat vaikystės ar paauglystės, jus gerai nuteikiančias ar aktyvuojančias ir apsnūsti neleidžiančias arba kaip tik raminančias ir sušildančias spalvas (priklausomai nuo likusios energijos rezervo, bet stipriai rekomenduoju apsirengimo nepalikti pačiu paskutiniu klausimu, tai padės jums išlaikyti vidinį integralumą ir truputį erdvės sau), jus formavusius filmų herojus, muzikos dievukus, įmagnetinančius mėgstamiausių filmų ir knygų veikėjus ir aktyvuokit juos savo deriniuose. Kad ir kas tai būtų. Neleiskit kalėdiniam cosplay uždiriguoti jūsų minčių.
          </Text>
          <Text pt='2' fontSize='xl'>
          Gal pastaruoju metu jautėtės gerai savo kūne ir vis dar norisi tuo džiaugtis? Tegu būna jūsų šventiniai išėjimai sensualūs ir žaidimiški. Gal švęsite kažkur iškeliavę, su pilnu kultūros kalendoriumi ir įkvepiančia Naujųjų išvakarių opera? Susipakuokit savo prabangiausią dramatišką suknelę su puošniausią juvelyrika, nes tam - tobulas metas. Tirpstančios snaigės (jos dabar juk visada greit tirpsta) jus užhipnotizavo ir akinantis baltumas dabar suteikia vilties? Renkitės baltai. O gal kaip tik norisi pasidaryti pauzę nuo šio pertekliaus epizodo ir ketinat likti su džinsais ir geriauysiais draugais? Irgi gera mintis, nes visos mintys apie savęs tausojimą ir paisymą yra geros mintys, o džinsai yra universaliausias spintos kareivėlis, tai užteks puošnesnio švarko su bateliais ir raudono lūpdažio ant absoliučiai "nuogo" veido. 
          </Text>
          {/* <Box minH='1vw' /> */}
          <Text pt='2' fontSize='xl'>
            Kad ir kuo dabar gyvenat ar norėtumėt tuo gyventi daugiau - inkorporuokit tai į savo derinius. Prisiminkit ir labiausiai sužavėjusius atostogų momentus (man tai buvo apsilankymas flamenco suknelių ir aksesuarų parduotuvėje Ispanijos pietuose, kurioje būrys vietinių moterų su savo dukromis emocionaliai rinkosi, matavosi ir vizualizavo artėjančio flamenco festivalio tradicinius įvaizdžius, kuriame visos kartu šoks flamenco). O jeigu nieko įkvepiančio pastaruoju metu neįvyko - išgalvokit savo svajonių įkvėpimus.  
          </Text>
         <Text pt='2' fontSize='xl'>
          Būkite ir atrodykite taip sentimentaliai kaip jums norisi. Taip nešiuolaikiškai ir nuoširdžiai, kaip tik įmanoma. Žaiskit, bandykit, matuokitės ir realizuokitės. Aiškių taisyklių per šventes nėra (jeigu nevaržo aprangos kodas). Gal tik nerašytas susitarimas palaikyti bendrą šventinę dvasią pirma palaikant save pačius.
          </Text>
          <Text pt='2' fontSize='xl'>
          Tai su po truputį artėjančiomis, būkit sau atlaidesni ir nepamirškit, kad visa tai yra skirta ir jums.
          </Text>
          <Box minH='1vw' />
        </Box>
    </CardBody>
    </Center>
    </Card>
    </Center>
    <Box minH='2vw' />
    </>
    )
  }